import React from 'react'
import { graphql } from 'react-apollo'
import { Redirect, Route, RouteProps } from 'react-router'

import { branch, compose, renderComponent } from 'recompose'

import CenteredSpinner from 'components/CenteredSpinner'
import { User } from 'generated/types'
import { withApolloErrorHandler } from 'utils/Apollo'
import Environment, { withEnv } from 'utils/environment'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'

import userQuery from './gql/user.query.gql'

type Props = RouteProps

type InnerProps = {
  env: Environment
} & WithFlowRouterProps

type AddedProps = {
  redirectTo?: string
}

type EnhancedProps = Props & AddedProps

type GqlProps = {
  user: User
}

const enhance = compose<AddedProps, Props>(
  withEnv,
  withFlowRouter,
  withApolloErrorHandler('RegistrationCheck', () => () => false),
  graphql<InnerProps, GqlProps, {}, {}>(userQuery, {
    options: {
      fetchPolicy: 'network-only',
    },
    props: ({ data, ownProps: { flow, setFlowAndUseUpdateRegMutation } }) => {
      if (data.loading) {
        return {
          loading: true,
        }
      } else {
        // Do not redirect for onboarding flows
        if (
          ![
            'later',
            'spend',
            'core',
            'tiered',
            'directToMobile',
            'mightyOakCardOnboarding',
          ].includes(flow)
        ) {
          return { loading: false }
        }

        // Redirect to root page for all error including Unauthenticated error
        if (data.error) {
          if (flow === 'directToMobile' || flow === 'mightyOakCardOnboarding') {
            setFlowAndUseUpdateRegMutation('tiered')
          }
          return { loading: false, redirectTo: '/' }
        }
      }
    },
  }),
  branch(({ loading }) => loading, renderComponent(CenteredSpinner)),
)

const PrivateRoute: React.SFC<EnhancedProps> = props => {
  if (props.redirectTo) {
    return <Redirect to={props.redirectTo} />
  } else {
    return <Route path={props.path} component={props.component} />
  }
}

export default enhance(PrivateRoute)
